import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, first } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";


type Entity = models.GuiaRechazadaZEDto;
type Column = kea.Grid2Column<Entity>;

/**Columnas fijas del grid */
const columnasFijas: Column[] = [
    { title: "Folio", cell: x => ({ data: x.Folio }) },
    { title: "Motivo rechazo", cell: x => ({ data: x.MotivoRechazo }) },

    { title: "Cliente origen", cell: x => ({ data: x.NombreClienteOrigen }) },
    { title: "Sucursal origen", cell: x => ({ data: x.NombreSucursalOrigen }) },

    { title: "Cliente destino", cell: x => ({ data: x.NombreClienteDestino }) },
    { title: "Sucursal destino", cell: x => ({ data: x.NombreSucursalDestino }) },
];

interface BotonesDeps {

}

/**Obtiene las columnas del grid */
function columnas(deps: BotonesDeps): Column[] {

    return [...columnasFijas];
}

export interface Props {
    value: Entity[];
}

export class GuiasRechazadasList extends React.PureComponent<Props> {

    render() {
        const cols = columnas(this);
        return (
            <kea.Panel title="Guias rechazadas">
                <kea.Grid2 items={this.props.value} columnas={cols} hideBusqueda />
            </kea.Panel>
        );
    }
}



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/viajesZE/verificar/listas/rechazadas.tsx